import React, { useState,useEffect,useRef } from 'react';
import CallHeaderPreview from './CallHeaderPreview.jsx'
import {AgentButton}  from 'global-components-library';
import { Singleton } from '../../../js/Singleton';
import ContainerDataPreview from '../Others/ContainerDataPreview.jsx';;
import {USER_STATE} from '../../../constants';
import {manualCall} from '../../../redux/actions/A_messages_to_SM';
import { setPhoneToCall,setIsRunningClock,saveTotalPreviewTime } from '../../../redux/actions/A_preview.js';
import { useDispatch, useSelector } from 'react-redux';
import { actionPreviewRecord } from '../../../redux/actions/A_messages_to_SM';
import { getCurrentTimeInSec } from '../../../js/helpers/Utils/formats.js';
import DialingLogPreview from '../Others/DialingLogPreview.jsx';
import { SingletonSharedData } from '../../../js/singletonSharedData.js';
import CallWindowSimultaneosPreview from '../SimultaneosRecsPreview/CallWindowSimultaneosPreview.jsx';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js';
import { Logger } from '../../../js/helpers/Logger.js';

const language = new Singleton();
const sharedData = new SingletonSharedData();
const  APIFact = new APIFactory();
const apiCont = APIFact.buildClient();

const CallWindowPreview = ({userState,fillAlertPreviewModal, dataCall}) =>{
  const [isRunning,setIsRunning]=useState(true);
  const [phoneToCall,setPhoneToCallS] = useState(''); 
  const record = useSelector(state => state.preview);
  const dataContact = useSelector(state => state.preview.data);
  const totalPreviewTime = useSelector(state => state.preview.totalPreviewTime);
  const dispatch = useDispatch();
  const {simultaneosRecs} = useSelector(state=>state.preview);


 useEffect(() => {
  setPhoneToCallS(record.phoneToCall);
  dispatch(setIsRunningClock(true));
 }, []);
  
  useEffect(() => {
    let run = userState !== USER_STATE.CALL_OUT;
    isRunning !== run && setIsRunning(run);
  }, [userState])


  const actionCall = () => {
    dispatch(setIsRunningClock(false));
    callPreview(phoneToCall);
  }
  
  const callPreview = (phoneToCall) => {
    let time = getCurrentTimeInSec();
    dispatch(saveTotalPreviewTime(time));
    let data = {
      CamId: record.camId, CallKey: record.callKey, 
      Phone: phoneToCall,Data: "", ExistsCallout: 0, CallMode: 0, integration:false
    };
    dispatch(setPhoneToCall(phoneToCall));
    dispatch(manualCall(data));
  }
  const discart = () => {
    let timeout = sharedData.getRequestTimeout();
        let userId = sharedData.getParameters().UserID;
        let objectResponseTransfer = apiCont.getObjectResponse();
    
        apiCont.transferCall(userId, null, objectResponseTransfer, timeout);
        objectResponseTransfer.onError = function (messageError) {
            Logger.Error('[CallWindowPreview][discard]',messageError)
        };
        objectResponseTransfer.onSuccess = function  (objectResponseTransfer) {  

          sharedData.setAgentList(objectResponseTransfer.AgentesList)
        } 
    let time = getCurrentTimeInSec();
    let previewTime = time - record.initialTimeSec + totalPreviewTime;
    dispatch(actionPreviewRecord({process:0, camId:record.camId, callOutId:record.callOutId, previewTime, callId:0}))
  }  

  return(
    <div className="cwp-callSpacePreview">
      {simultaneosRecs ? 
        <CallWindowSimultaneosPreview
        userState={userState}
        dataCall={dataCall}
        /> 
        :
      <div>
        <CallHeaderPreview
          campaignName={record.campaignName}
          iconCallFrame={record.iconCampaing}
          callKey={record.callKey}
          seconds = {record.previewTime}
          phones = {record.phones}
          isRunning={isRunning}   
          userState={userState}
          setPhoneToCall={setPhoneToCallS}
        />
        <div className='cwp-divisorLine'></div>
         <div className="cwp-containerInformation">
            <div className="cwp-leftSide">
              <div className={`cwp-btnContainer`}>
                {record.previewDiscard && <div className='cwp-styleBtns'><AgentButton type='secondary' color={'blue'} icon={'discart'} onClick={discart}>{language.getText('GUIPreviewdiscard')}</AgentButton></div>}      
                <div className='cwp-styleBtns'><AgentButton type='primary' color={'green'} icon={'call'}  onClick={actionCall}>{language.getText('GUIPreviewdial')}</AgentButton></div>
                {record.permissionDelete && <div className='cwp-styleBtns'><AgentButton type='secondary' color={'red'} icon={'trash'} onClick={()=>fillAlertPreviewModal()}>{language.getText('GUIPreviewdelete')}</AgentButton></div>}
              </div>
              <ContainerDataPreview
                  userState={userState}
                  data={dataContact}
                  headers={record.headers}
                  callKey={record.callKey}
                  disableInput={true}
              />
            </div>
            <DialingLogPreview callOutId={record.callOutId} camId={record.camId}  userId={sharedData.getParameters().UserID}/>
          </div>
          </div>}
    </div>  
  )
}

export default CallWindowPreview;



// WEBPACK FOOTER //
// ./src/components/workSpace/CallComponents/CallWindowPreview.jsx